// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Gj9b","test":"Home_test__2WFAQ"};